<figure class="gc-braid" [attr.aria-label]="t('braidLabel')">
  <svg
    class="gc-braid__svg"
    [attr.viewBox]="'0 0 ' + width + ' ' + height"
    [attr.width]="width"
    [attr.height]="height"
    role="img"
    [attr.aria-label]="t('braidLabel')"
  >
    <!-- Blokbanden in de blokkleuren van de tabel. -->
    @for (block of blocks; track block.id) {
      <rect
        class="gc-braid__block"
        [attr.data-block]="block.color"
        [attr.x]="block.x"
        [attr.y]="bandTop"
        [attr.width]="block.width"
        [attr.height]="bandHeight"
      ></rect>
    }
    @if (highlightColumn(); as selected) {
      <rect
        class="gc-braid__selected"
        [attr.x]="selected.x - columnWidth / 2"
        [attr.y]="bandTop - 2"
        [attr.width]="columnWidth"
        [attr.height]="bandHeight + 4"
        rx="3"
      ></rect>
    }
    <text class="gc-braid__lane" x="8" [attr.y]="laneY.sphinx" dominant-baseline="central">{{ t('braidLaneSphinx') }}</text>
    <text class="gc-braid__lane" x="8" [attr.y]="laneY.vessel" dominant-baseline="central">{{ t('braidLaneVessel') }}</text>
    <!-- Lock-rijen: hier kruisen de strengen naar het andere slotkruis. -->
    @for (column of columns(); track column.id) {
      @if (column.isLock) {
        <line class="gc-braid__lock-tick" [attr.x1]="column.x" [attr.x2]="column.x" [attr.y1]="bandTop" [attr.y2]="bandTop + bandHeight"></line>
        <text class="gc-braid__lock-gate" [attr.x]="column.x" [attr.y]="bandTop + bandHeight + 15" text-anchor="middle">{{ column.equinoxGate }}</text>
      }
    }
    <polyline class="gc-braid__strand gc-braid__strand--counter" [attr.points]="counterStrand"></polyline>
    <polyline class="gc-braid__strand gc-braid__strand--equinox" [attr.points]="equinoxStrand"></polyline>
    @if (currentColumn(); as current) {
      <text class="gc-braid__now" [attr.x]="current.x" [attr.y]="bandTop - 6" text-anchor="middle">{{ t('braidNow') }}</text>
    }
    <!-- Klik- en hover-vlakken per kolom (tooltip = tijdperk + kruis). -->
    @for (column of columns(); track column.id) {
      <rect
        class="gc-braid__hit"
        [class.is-selectable]="selectable()"
        [attr.data-period-id]="column.periodId"
        [attr.x]="column.x - columnWidth / 2"
        [attr.y]="bandTop"
        [attr.width]="columnWidth"
        [attr.height]="bandHeight + 20"
        (click)="select(column.periodId)"
      >
        <title>{{ column.tooltip }}</title>
      </rect>
    }
  </svg>
  <figcaption class="gc-braid__legend">
    <span class="gc-braid__legend-item"><span class="gc-braid__swatch gc-braid__swatch--equinox"></span>{{ t('braidLegendEquinox') }}</span>
    <span class="gc-braid__legend-item"><span class="gc-braid__swatch gc-braid__swatch--counter"></span>{{ t('braidLegendCounter') }}</span>
  </figcaption>
</figure>
